<template>
    <div id="nav">
        <ul>
           <!--<li>
              <router-link to="/">
                <span class="mdi mdi-view-dashboard-outline"></span> Dashboard
              </router-link>
            </li>-->
            <li>
              <router-link :to="{ name: routes.Reports.ReportIndex }">
                <span class="mdi mdi-home-city-outline"></span> Reports
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'report-type-templates' }">
                <span class="mdi mdi-home-edit-outline"></span> Report Types
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'report-section-template-index' }">
                <span class="mdi mdi-vector-intersection"></span> Section Templates
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: routes.Templates.FieldTemplateIndex }">
                <span class="mdi mdi-format-letter-matches"></span> Field Templates
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'standard-phrase-index' }">
                <span class="mdi mdi-message-text-outline"></span> Standard Phrases
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'vendor-checklist' }">
                <span class="mdi mdi-text-box-check-outline"></span> Vendor Checklist
              </router-link>
            </li>
            <!--<li>
              <router-link to="/">Settings</router-link>
            </li>-->
        </ul>
    </div>
</template>

<script>
  import { RouteNames } from '../utils/constants'

  export default {
    data() {
      return {
        routes: RouteNames
      }
    }
  }
</script>

<style lang="scss">  
  #nav {
    position: fixed;
    padding-top: 6px;
    padding-left: 1em;

    ul {
      list-style: none;
      padding: 0;
      position: fixed;

      li {
        margin-bottom: 0.8em;

        a, a:active, a:focus, a:visited {
          color: rgb(56, 62, 66);
          text-decoration: none;
        }

        a:hover {
          color: #208bc9;
        }
      }
    }
  }
</style>